import {
  love,
  paper,
  lucky,
  lightning,
  number2,
  cool,
  sakura,
  clova,
  champagne,
  gift,
  celebration,
  newyear,
  slotmachine,
  runningwoman,
  health,
  health2,
  chick,
  ear,
  oksing,
  good,
  graduate,
  wedding,
  baby,
  ring,
  wind,
  power,
  maxscore,
  money,
  soon,
  happy1,
  happy2,
  devil,
  clap,
  nosmoking,
  moneyface,
  purpledevil,
  gini,
  kite,
  couple,
  qustion,
} from '../../img';

import {
  clock,
  sun,
  pen,
  loveRight,
  luckyRight,
  lightningRight,
  star,
  brige,
  leaf,
  newyearRight,
  graduateRight,
  slotmachineRight,
  melody,
  trumpet,
  race,
  runningman,
  whiterabbit,
  rabbit,
  hand,
  thumb,
  girl,
  catwoman,
  weddingRight,
  babyRight,
  loveRiibon,
  strong,
  starRight,
  moneyRight,
  moneyRight2,
  book,
  smail,
  sunglasses,
  wink,
  omg,
  clapRight,
  nosmokingRight,
  babyRight2,
  redSign,
  goal,
  happyRight,
  circus,
  kiteRight,
  mars,
  number3,
  x,
  qustionRight,
} from '../../img';
import {
  healthyCategory,
  loveCategory,
  luckyCategory,
  moneyCategory,
  studyCategory,
  workCategory,
} from '../../img';

import {
  Gaho,
  EXO,
  Zobin,
  Since,
  WikiMiki,
  NoSmokingAlbem,
  SuperStarAlbem,
  FanfareAlbem,
  DaySixAlbem,
  StartAlbem,
  JRabbitAlbem,
  SoranAlbem,
  IOIAlbem,
  SOMDEFAlbem,
  LESSERAFIMAlbem,
  EternityAlbem,
  BlackPinkAlbem,
  NCT127Albem,
  IUAlbem,
  IZONEAlbem,
  BlockBAlbem,
  GunnyAlbem,
  WJSNAlbem,
  PinkfloyedAlbem,
  YUNAlbem,
  MeloManceAlbem,
  BTSAlbem,
  WheeSungAlbem,
  MightyMouthAlbem,
  AMAlbem,
  SeeYaAlbem,
  DelegationAlbem,
  RedVelvetAlbem,
  OlltiiAlbem,
  JoyAlbem,
  AespaAlbem,
  TwiceAlbem,
  KihaAlbem,
  NE1Albem,
  SejeongAlbem,
  FlyAlbem,
} from '../../img';

import {
  FlowerRoadMeme,
  NE1Meme,
  FlyMeme,
  KihaMeme,
  NoSmokingMeme,
  AespaMeme,
  JoyMeme,
  OlltiiMeme,
  DelegationMeme,
  SeeYaMeme,
  AMMeme,
  MightyMouthMeme,
  WheeSungMeme,
  BTSMeme,
  MeloManceMeme,
  YUNMeme,
  PinkfloyedMeme,
  GunnyMeme,
  BlockBMeme,
  IZONEMeme,
  IUMeme,
  NCT127Meme,
  BlackPinkMeme,
  SOMDEFMeme,
  JRabbitMeme,
  StartMeme,
  DaySixMeme,
  SuperStarMeme,
  WikiMikiMeme,
  SinceMeme,
  EXOMeme,
  EternityMeme,
  TwiceMeme,
  ZobinMeme,
  IOIMeme,
  WJSNMeme,
  RedVelvetMeme,
  GahoMeme,
  FanfareMeme,
  LESSERAFIMMeme,
} from '../../img';

export const imgFileLeft = [
  qustion,
  champagne,
  lightning,
  health2,
  baby,
  power,
  good,
  nosmoking,
  money,
  moneyface,
  slotmachine,
  newyear,
  oksing,
  lucky,
  love,
  ring,
  gift,
  wedding,
  maxscore,
  runningwoman,
  soon,
  graduate,
  sakura,
  clova,
  happy1,
  happy2,
  celebration,
  purpledevil,
  ear,
  gini,
  clap,
  wind,
  paper,
  //여기 까지 씀
  number2,
  cool,
  health,
  chick,
  devil,
  kite,
  couple,
];
export const imgFileRight = [
  qustionRight,
  x,
  rabbit,
  strong,
  babyRight2,
  wink,
  luckyRight,
  sunglasses,
  nosmokingRight,
  lightningRight,
  circus,
  moneyRight2,
  slotmachineRight,
  trumpet,
  moneyRight,
  clapRight,
  thumb,
  pen,
  redSign,
  loveRight,
  clock,
  weddingRight,
  catwoman,
  smail,
  loveRiibon,
  book,
  sun,
  runningman,
  graduateRight,
  race,
  goal,
  omg,
  newyearRight,
  star,
  melody,
  mars,
  kiteRight,
  number3,
  babyRight,
  starRight,
  hand,
  brige,
  leaf,
  whiterabbit,
  //여기까지 씀
  girl,
  happyRight,
];

export const slot = [
  [
    champagne,
    x,
    healthyCategory,
    '건강운',
    'AlcoholFree',
    '마신 게 하나도 없는데',
    'Alcohol-Free',
    '트와이스',
    TwiceAlbem,
    TwiceMeme,
    'https://youtu.be/XA2YEHn-A8Q',
  ],
  [
    lightning,
    rabbit,
    healthyCategory,
    '건강운',
    'Energy',
    'MY 에너지 나는 너의 에너지 One Two Three E N E R G Y',
    'Energy',
    '마이티마우스',
    MightyMouthAlbem,
    MightyMouthMeme,
    'https://youtu.be/X9qAHFXJPDs',
  ],
  [
    health2,
    strong,
    healthyCategory,
    '건강운',
    'Gunny',
    '지금부터 나와같이 어서빨리 운동하자',
    '운동하자',
    '건이',
    GunnyAlbem,
    GunnyMeme,
    'https://youtu.be/K07faTcthWc',
  ],
  [
    baby,
    babyRight2,
    healthyCategory,
    '건강운',
    'ForeverYoung',
    '후회 없는 젊음이 타오르게 Forever young',
    'Forever Young',
    '블랙핑크',
    BlackPinkAlbem,
    BlackPinkMeme,
    'https://youtu.be/wV6qz89SU2c',
  ],
  [
    power,
    wink,
    healthyCategory,
    '건강운',
    'antifragile',
    "I'm antifragile antifragile Anti ti ti ti fragile fragile",
    'antifragile',
    '르세라핌',
    LESSERAFIMAlbem,
    LESSERAFIMMeme,
    'https://youtu.be/pyf8cbqyfPs',
  ],
  [
    thumb,
    luckyRight,
    healthyCategory,
    '건강운',
    'Allgood',
    "Everything, everything's fine 너대로 충분한 걸",
    'all good',
    '썸데프',
    SOMDEFAlbem,
    SOMDEFMeme,
    `https://youtu.be/E1JeFr3RTf0`,
  ],
  [
    power,
    sunglasses,
    healthyCategory,
    '건강운',
    'Soran',
    '넌 모를 거야 내가 얼마나 준비된 어깨를 가졌는지',
    '준비된어깨',
    '소란',
    SoranAlbem,
    SOMDEFMeme,
    'https://youtu.be/trDQyIOlpjE',
  ],
  [
    nosmoking,
    nosmokingRight,
    healthyCategory,
    '건강운',
    'NoSmoking',
    '그대 담배를 끊어봐요 (담배 연기 싫어) 건강에도 안 좋은 걸 왜 자꾸 피우시나',
    '금연',
    '건아들',
    NoSmokingAlbem,
    NoSmokingMeme,
    'https://youtu.be/KKtwSLubpxs',
  ],

  [
    money,
    circus,
    moneyCategory,
    '재물운',
    'Lotto',
    'I just hit the lotto',
    'Lotto',
    'EXO',
    EXO,
    EXOMeme,
    'https://youtu.be/tbe3pe2BtwA',
  ],
  [
    moneyface,
    money,
    moneyCategory,
    '재물운',
    'Money',
    "Money it's a hit I'm in the hi-fidelity first class traveling set",
    'money',
    'Pink Floyd',
    PinkfloyedAlbem,
    PinkfloyedMeme,
    'https://youtu.be/-0kcet4aPpQ',
  ],
  [
    slotmachine,
    slotmachineRight,
    moneyCategory,
    '재물운',
    'BlockB',
    '야호 터졌다 Ja Ja Ja Jackpot',
    'jackpot',
    '블락비',
    BlockBAlbem,
    BlockBMeme,
    'https://youtu.be/83Yscg5vtVQ',
  ],
  [
    newyear,
    trumpet,
    moneyCategory,
    '재물운',
    'Fiesta',
    '축제는 절정인 걸 끝나지 않을 이건 Climax  나의 모든 순간이 아름답고 눈부셔',
    'fiesta',
    '아이즈원',
    IZONEAlbem,
    IZONEMeme,
    'https://youtu.be/eDEFolvLn0A',
  ],
  [
    oksing,
    moneyRight,
    moneyCategory,
    '재물운',
    'Coin',
    '승리를 손에 꽉 잡아 말아 쥐어 Worth more than jewels',
    'coin',
    '아이유',
    IUAlbem,
    IUMeme,
    'https://youtu.be/86BST8NIpNM',
  ],
  [
    lucky,
    clapRight,
    moneyCategory,
    '재물운',
    'DreamsComeTrue',
    'All your dreams come true 널 믿어 dreams come true',
    'dreams come true',
    'NCT127',
    NCT127Albem,
    NCT127Meme,
    'https://youtu.be/5g7dEUNG36U',
  ],

  //10

  [
    paper,
    pen,
    workCategory,
    '직장운',
    'Sign',
    '끝엔 해피엔딩일 거야 나도 해냈잖아 취뽀',
    'SIGN',
    'SINCE',
    Since,
    SinceMeme,
    'https://youtu.be/_eYhW_Z4nkA',
  ],

  [
    happy2,
    redSign,
    loveCategory,
    '애정운',
    'Happiness',
    '점점 더 좋은걸 난 나라서 행복해',
    '행복 (Happiness)',
    '	레드벨벳',
    RedVelvetAlbem,
    RedVelvetMeme,
    'https://youtu.be/JFgv8bKfxEs',
  ],
  [
    love,
    clock,
    loveCategory,
    '애정운',
    'InLovesTime',
    "In love's time, all you'll ever need In the life you lead will be guaranteed",
    "In Love's Time",
    'the delegation',
    DelegationAlbem,
    DelegationMeme,
    'https://youtu.be/zzVOHrKtL6Y',
  ],
  [
    ring,
    weddingRight,
    loveCategory,
    '애정운',
    'Marry',
    '아프지 마요 언제나 웃어요 약속할게요 그대만을 사랑해요 My Lover Lover 나와 결혼해줘요',
    '결혼할까요',
    '씨야',
    SeeYaAlbem,
    SeeYaMeme,
    'https://youtu.be/ykH4NB4dWrU',
  ],
  [
    love,
    catwoman,
    loveCategory,
    '애정운',
    'ConfessionOfAFriend',
    '친구로 친구로 지내야 한단 이유로 하지만 이제는 고백할께. 너를 사랑해',
    '친구의 고백',
    '2AM',
    AMAlbem,
    AMMeme,
    'https://youtu.be/E5B1ERDWB-w',
  ],
  [
    love,
    happyRight,
    loveCategory,
    '애정운',
    'Realslow',
    '사랑은 맛있어 달빛 젖은 햇살 머금은 세상의 선물',
    '사랑은 맛있다♡',
    '휘성',
    WheeSungAlbem,
    WheeSungMeme,
    'https://youtu.be/nL8dfpEsIDY',
  ],
  [
    gift,
    loveRight,
    loveCategory,
    '애정운',
    'Gift',
    '항상 평범했던 일상도 특별해지는 이 순간',
    '선물',
    '멜로망스',
    MeloManceAlbem,
    MeloManceMeme,
    'https://youtu.be/qYYJqWsBb1U',
  ],
  //20
  [
    wedding,
    book,
    loveCategory,
    '애정운',
    'WeddingDiary',
    '이렇게 우리 함께 늙자 오늘자 우리의 신혼일기',
    '신혼일기',
    '윤딴딴',
    YUNAlbem,
    YUNMeme,
    'https://youtu.be/UTku3JIxE7E',
  ], //21
  [
    maxscore,
    sun,
    loveCategory,
    '애정운',
    'Eternity',
    '우리 같이 영원을 꿈꾸자',
    '백년해로',
    '선우정아',
    EternityAlbem,
    EternityMeme,
    'https://youtu.be/jfTFyw6V5Sk',
  ],
  [
    runningwoman,
    runningman,
    workCategory,
    '직장운',
    '2NE1',
    '내가 봐도 내가 좀 끝내주잖아 네가 나라도 이 몸이 부럽잖아',
    '내가 제일 잘 나가',
    '2NE1',
    NE1Albem,
    NE1Meme,
    'https://youtu.be/j7_lSP8Vc3o',
  ],
  [
    graduate,
    graduateRight,
    studyCategory,
    '학업운',
    'Graduate',
    '함께했던 시간은 이젠 추억으로 남기고 서로 가야 할 길 찾아서 떠나야 해요',
    '졸업',
    '올티',
    OlltiiAlbem,
    OlltiiMeme,
    'https://youtu.be/sMgJvLYTWdM',
  ],
  [
    runningwoman,
    race,
    studyCategory,
    '학업운',
    'Gaho',
    '새로운 시작은 늘 설레게 하지 모든 걸 이겨낼 것처럼',
    '시작',
    '가호',
    Gaho,
    GahoMeme,
    'https://youtu.be/6LDg0YGYVw4',
  ],
  [
    runningwoman,
    race,
    workCategory,
    '직장운',
    'Gaho',
    '새로운 시작은 늘 설레게 하지 모든 걸 이겨낼 것처럼',
    '시작',
    '가호',
    Gaho,
    GahoMeme,
    'https://youtu.be/6LDg0YGYVw4',
  ],
  [
    sakura,
    goal,
    studyCategory,
    '학업운',
    'FlowerRoad',
    '젊고 아름다운 당신의 계절 여길 봐 예쁘게 피었으니까',
    '꽃길',
    '세정',
    SejeongAlbem,
    FlowerRoadMeme,
    'https://youtu.be/zumBqDr0FCk',
  ],
  [
    sakura,
    goal,
    workCategory,
    '직장운',
    'FlowerRoad',
    '젊고 아름다운 당신의 계절 여길 봐 예쁘게 피었으니까',
    '꽃길',
    '세정',
    SejeongAlbem,
    FlowerRoadMeme,
    'https://youtu.be/zumBqDr0FCk',
  ],
  [
    clova,
    omg,
    studyCategory,
    '학업운',
    'JRabbit',
    '웬만하면 크게 웃고 다시 시작해봐 오늘은 좋은일이 있을거야',
    '좋은일이 있을거야',
    '제이레빗',
    JRabbitAlbem,
    JRabbitMeme,
    'https://youtu.be/M9l-4V9krYo',
  ],
  [
    clova,
    omg,
    workCategory,
    '직장운',
    'JRabbit',
    '웬만하면 크게 웃고 다시 시작해봐 오늘은 좋은일이 있을거야',
    '좋은일이 있을거야',
    '제이레빗',
    JRabbitAlbem,
    JRabbitMeme,
    'https://youtu.be/M9l-4V9krYo',
  ], //30
  [
    happy2,
    runningman,
    studyCategory,
    '학업운',
    'Start',
    '이렇게 나는 떠나네 더 넓은 세상으로',
    '출발',
    '김동률',
    StartAlbem,
    StartMeme,
    'https://youtu.be/xgvckGs6xhU',
  ], //31
  [
    happy2,
    runningman,
    workCategory,
    '직장운',
    'Start',
    '이렇게 나는 떠나네 더 넓은 세상으로',
    '출발',
    '김동률',
    StartAlbem,
    StartMeme,
    'https://youtu.be/xgvckGs6xhU',
  ],
  [
    happy1,
    happyRight,
    studyCategory,
    '학업운',
    'DaySix',
    '반드시 웃는다 웃는다',
    '반드시 웃는다',
    '데이식스',
    DaySixAlbem,
    DaySixMeme,
    'https://youtu.be/g4V36AfI4Ng',
  ],
  [
    happy1,
    happyRight,
    workCategory,
    '직장운',
    'DaySix',
    '반드시 웃는다 웃는다',
    '반드시 웃는다',
    '데이식스',
    DaySixAlbem,
    DaySixMeme,
    'https://youtu.be/g4V36AfI4Ng',
  ],
  [
    celebration,
    newyearRight,
    studyCategory,
    '학업운',
    'Fanfare',
    '꿈꾸던 시간이 마치 오늘인 것만 같아 맘이 두근거리다 심장이 쿵 떨어져',
    '팡파레',
    '다비치',
    FanfareAlbem,
    FanfareMeme,
    'https://youtu.be/BtPHw6YLMN0',
  ],
  [
    celebration,
    newyearRight,
    workCategory,
    '직장운',
    'Fanfare',
    '꿈꾸던 시간이 마치 오늘인 것만 같아 맘이 두근거리다 심장이 쿵 떨어져',
    '팡파레',
    '다비치',
    FanfareAlbem,
    FanfareMeme,
    'https://youtu.be/BtPHw6YLMN0',
  ],
  [
    purpledevil,
    starRight,
    studyCategory,
    '학업운',
    'SuperStar',
    '괜찮아 잘 될거야 너에겐 눈부신 미래가 있어 후회없이만 산다면 그것이 Super Star',
    '슈퍼스타',
    '이한철',
    SuperStarAlbem,
    SuperStarMeme,
    'https://youtu.be/SruG2InmPeI',
  ],
  [
    purpledevil,
    starRight,
    workCategory,
    '직장운',
    'SuperStar',
    '괜찮아 잘 될거야 너에겐 눈부신 미래가 있어 후회없이만 산다면 그것이 Super Star',
    '슈퍼스타',
    '이한철',
    SuperStarAlbem,
    SuperStarMeme,
    'https://youtu.be/SruG2InmPeI',
  ],
  [
    ear,
    melody,
    studyCategory,
    '학업운',
    'Jobin',
    '무엇이든 상상하기만하면 이루어진다 로또는 비교도 안될 성공이',
    '듣기만 해도 성공하는 음악',
    '조빈',
    Zobin,
    ZobinMeme,
    'https://youtu.be/o9hpUJLa1gs',
  ],
  [
    ear,
    melody,
    workCategory,
    '직장운',
    'Jobin',
    '무엇이든 상상하기만하면 이루어진다 로또는 비교도 안될 성공이',
    '듣기만 해도 성공하는 음악',
    '조빈',
    Zobin,
    ZobinMeme,
    'https://youtu.be/o9hpUJLa1gs',
  ],
  [
    gini,
    mars,
    luckyCategory,
    '행운',
    'AsYouWish',
    '이루리 이루리 La 모두 다 이뤄질 거야',
    '이루리',
    '우주소녀',
    WJSNAlbem,
    WJSNMeme,
    'https://youtu.be/2Q9G6R2hKIQ',
  ],
  [
    gini,
    girl,
    luckyCategory,
    '행운',
    'IOI',
    '시간은 충분해 조급해하지마 Trust yourself 너 포기하지마',
    'Dream Girls',
    '아이오아이',
    IOIAlbem,
    IOIMeme,
    'https://youtu.be/8Zu_yO4pNEY',
  ],
  [
    kite,
    kiteRight,
    luckyCategory,
    '행운',
    'NewYear',
    '새해 복만으로도 돼 절대 잘 하지 마 (돼) 열심히 하지 마 (돼)',
    '새해 복',
    '장기하와 얼굴들',
    KihaAlbem,
    KihaMeme,
    'https://youtu.be/yDCfuQLPhyY',
  ],

  [
    chick,
    babyRight,
    luckyCategory,
    '행운',
    'Fly',
    '새롭게 펼쳐봐 또 날아봐 이제',
    '날개',
    '태연',
    FlyAlbem,
    FlyMeme,
    'https://youtu.be/YIrON_YUE70',
  ],
  [
    gini,
    starRight,
    luckyCategory,
    '행운',
    'Aespa',
    '나를 지켜줄 거야 아껴왔던 작은 사랑도',
    'Dreams Come True',
    'Aespa',
    AespaAlbem,
    AespaMeme,
    'https://youtu.be/H69tJmsgd9I',
  ],
  [
    clap,
    clapRight,
    luckyCategory,
    '행운',
    'Hello',
    '외로운 날들이여 모두 다 안녕 내 마음속의 눈물들도 이제는 안녕 Oh',
    '안녕',
    '조이',
    JoyAlbem,
    JoyMeme,
    'https://youtu.be/lNvBbh5jDcA',
  ],
  [
    sakura,
    brige,
    luckyCategory,
    '행운',
    'Spring',
    '꽃 피울 때까지 그곳에 좀 더 머물러줘',
    '봄날',
    'BTS',
    BTSAlbem,
    BTSMeme,
    'https://youtu.be/xEeFrLSkMm8',
  ],
  [
    soon,
    whiterabbit,
    luckyCategory,
    '행운',
    'cool',
    '아름답잖아. 지금 이대로. 난 괜찮은 거야',
    'COOL',
    '위키미키',
    WikiMiki,
    WikiMikiMeme,
    'https://youtu.be/AHikmx0eVXM',
  ],
];

export const category = [
  qustionRight,
  healthyCategory,
  loveCategory,
  luckyCategory,
  moneyCategory,
  studyCategory,
  workCategory,
];
export const data = [
  ['money', '💰', '재물운'],
  ['health', '💪', '건강운'],
  ['love', '💗', '애정운'],
  ['study', '📚', '학업운'],
  ['lucky', '🎁 ', '행운'],
  ['work', '👔', '직장운'],
];
